module.exports = __webpack_public_path__ + "f7ecc8a71ef6613fe4e80ac94d171335.svg";